import React from "react";
import ModalEditSummary from "../../../company/profil/overview/modal/modal-edit-summary";
import * as T from "../../../../../controller/company-ctr/types/types-company-page";

export default function ModalSummary(props: T.IpropsEditSummary) {
  return <ModalEditSummary {...props} />;
}
